import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import { set } from "lodash";
import { errorJsonHasErrors } from "./Input_Fns";

export const InputEmail = ({
  label = "Email",
  name = "Email",
  value,
  required = false,
  maxLength = 63,
  onChange,
  tooltip = "",
  onError = null,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    let ne = structuredClone(errors)
    let err = ""

    if (e.target.name === name) {
      if (required === true && value === "") {
        err = "Please enter a " + label
      } else if (value !== "") {
        // let match = value.match("/^\S$/")
        // console.log(match)
        // if (match === null) {
        //   err = "Please enter a valid email"
        // }
      }
      ne = set(ne, e.target.name, err)
      setErrors(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
      //console.log(ne)
      //console.log(name)
      //console.log(ne[name])

    }
  }
  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={label}
        name={name}
        type="text"

        required={required}
        slotProps={{
          htmlInput: { maxLength: maxLength },
        }}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        size="small"
        sx={{ width: 400 }}
        value={value}
        onChange={onChange}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        {...others}
      />
    </Tooltip>
  );
};
